
export default function ({ groups }) {
  return groups;
}
